export default "__VITE_ASSET__CBnCTZ2G__"